// Dynamic Margin Calculator
// This script calculates the height of .announcement-bar and .shopify-section--header
// Then sets the sum as margin-top for .anchor elements

document.addEventListener('DOMContentLoaded', function() {
  // Function to calculate and set margin
  function setAnchorMargin() {
    // Get elements
    const announcementBar = document.querySelector('.announcement-bar');
    const shopifyHeader = document.querySelector('.shopify-section--header');
    const anchorElement = document.querySelector('.anchor-container');
    
    // Calculate heights (using 0 if element doesn't exist)
    const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
    const headerHeight = shopifyHeader ? shopifyHeader.offsetHeight : 0;
    
    // Calculate total height
    //const totalHeight = announcementHeight + headerHeight;
    const totalHeight = headerHeight;
    
    // Apply margin-top to anchor element
    if (anchorElement) {
      anchorElement.style.marginTop = `${totalHeight}px`;
      //console.log(`Applied margin-top of ${totalHeight}px to .anchor element`);
    }
  }
  
  // Run on page load
  setAnchorMargin();
  
  // Also run on window resize to account for responsive header changes
  window.addEventListener('resize', setAnchorMargin);
});